export default __webpack_public_path__ + "static/clouds-7d72f6bd4e5cf277db68cb61470ae876.webm";